import PropTypes from 'prop-types';
import Link from 'next/link';
import { Grid } from '@ui-propulsion/react-components';
import parse from 'html-react-parser';
import CtaButton from '../../ctaButton/ctaButton';
import handleCTAClick from '../../../services/helpers/handleCTAClick';
import SmartImage from '../../smartImage/smartImage';
import IconList from '../../iconList/iconList'; // Import IconList
import styles from './twoColumnTextImageMobile.module.scss';

export default function TwoColumnTextImageMobile({
  title = '',
  description = '',
  list = [],
  images = [],
  cta = null,
  ctaType = '',
  theme = 'white',
  imagePositionInMobileView = 'Below Content',
  descriptionTextAlign,
  roundedImage = '',
}) {
  const imageClass = `${styles.image} ${
    imagePositionInMobileView === 'Below Content' ? styles.imageBelow : ''
  } ${roundedImage.length > 0 ? styles[roundedImage] : ''}`;
  const contentPaddingClass = `${styles.title} ${
    imagePositionInMobileView === 'Below Content' ? '' : styles.contentPadding
  }`;
  const ctaButton = cta && (
    <div className={`${styles.ctaContainer} ${styles[ctaType]}`}>
      <CtaButton
        label={cta?.label}
        aria-label="radius-bank"
        data-testid="cta"
        variant={cta?.variant}
        color={cta?.color}
        type="button"
        fullWidth
        onClick={(e) => handleCTAClick(e, cta)}
        href={cta?.link}
        id="radius_module_cta"
      />
    </div>
  );
  const textSection = (
    <Grid
      item
      xs={12}
      sm={5}
      md={5}
      lg={5}
      className={`${
        imagePositionInMobileView === 'Below Content' ? styles.textUpper : ''
      } ${styles[descriptionTextAlign]}`}
    >
      {title && <h2 className={contentPaddingClass}>{parse(title)}</h2>}
      {description && (
        <div className={styles.description}>{parse(description)}</div>
      )}
      {list?.length > 0 && <IconList list={list} />}
      {cta && <div className={styles.mobileLayout}>{ctaButton}</div>}
    </Grid>
  );
  const imageSection = (
    <Grid item className={`${styles.icon}`} xs={12} sm={6} md={6} lg={6}>
      <div className={imageClass}>
        {images?.map((img, ci) =>
          img?.link ? (
            <Link href={img?.link} key={`row-${ci}`.toString()}>
              <SmartImage
                src={img?.src}
                alt={img?.alt}
                loading="lazy"
                width={img.width}
                height={img.height}
              />
            </Link>
          ) : (
            <SmartImage
              src={img?.src}
              alt={img?.alt}
              loading="lazy"
              key={`row-${ci}`.toString()}
              width={img.width}
              height={img.height}
            />
          )
        )}
      </div>
    </Grid>
  );

  return (
    <section>
      <div className={`${styles.info} ${styles[theme]} ${styles.mobileView}`}>
        <Grid container>
          {imagePositionInMobileView === 'Below Content'
            ? textSection
            : imageSection}
          {imagePositionInMobileView === 'Below Content'
            ? imageSection
            : textSection}
        </Grid>
      </div>
    </section>
  );
}

TwoColumnTextImageMobile.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      alt: PropTypes.string,
      link: PropTypes.string,
    })
  ),
  cta: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
  }),
  ctaType: PropTypes.string,
  theme: PropTypes.string,
  imagePositionInMobileView: PropTypes.string,
};
